import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "page" }
const _hoisted_2 = { class: "container-fluid breadcrumbs d-none d-md-block" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_9 = {
  id: "main",
  class: ""
}
const _hoisted_10 = { class: "container px-xs-0 beratung" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "login-heading" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "login-content logged-in" }
const _hoisted_15 = { class: "login-content--subnav" }
const _hoisted_16 = { class: "login-content--main flow" }
const _hoisted_17 = { class: "h1" }
const _hoisted_18 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_19 = { class: "appointment-list" }
const _hoisted_20 = { class: "appointment--datetime" }
const _hoisted_21 = { class: "appointment--datetime--item" }
const _hoisted_22 = { class: "appointment--datetime--item" }
const _hoisted_23 = {
  key: 0,
  class: "appointment--buttons"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 2,
  class: "btn btn-primary-custom btn-disabled",
  "aria-label": "Test C"
}
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 4,
  disabled: "",
  class: "btn btn-primary-custom",
  "aria-label": "Test E"
}
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { class: "btn btn-primary-custom btn-disabled" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "appointment--consultant" }
const _hoisted_33 = ["href"]
const _hoisted_34 = { class: "appointment--type" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "appointment-list" }
const _hoisted_37 = { class: "appointment--datetime" }
const _hoisted_38 = { class: "appointment--datetime--item" }
const _hoisted_39 = { class: "appointment--datetime--item" }
const _hoisted_40 = { class: "appointment--buttons" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 4 }
const _hoisted_46 = { class: "appointment--consultant" }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "appointment--type" }
const _hoisted_49 = {
  class: "accordion",
  id: "howToAccordion"
}
const _hoisted_50 = { class: "accordion-item" }
const _hoisted_51 = {
  class: "accordion-header",
  id: "headingOne"
}
const _hoisted_52 = {
  class: "accordion-button",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseOne",
  "aria-expanded": "true",
  "aria-controls": "collapseOne"
}
const _hoisted_53 = {
  id: "collapseOne",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "headingOne",
  "data-bs-parent": "#howToAccordion"
}
const _hoisted_54 = { class: "accordion-body" }
const _hoisted_55 = { class: "onb-numbered-list" }
const _hoisted_56 = { class: "onb-numbered-list--item" }
const _hoisted_57 = { class: "onb-numbered-list--item" }
const _hoisted_58 = { class: "onb-numbered-list--item" }
const _hoisted_59 = { class: "onb-numbered-list--item" }
const _hoisted_60 = { class: "accordion-item" }
const _hoisted_61 = {
  class: "accordion-header",
  id: "headingTwo"
}
const _hoisted_62 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseTwo",
  "aria-expanded": "false",
  "aria-controls": "collapseTwo"
}
const _hoisted_63 = {
  id: "collapseTwo",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingTwo",
  "data-bs-parent": "#faqAccordion"
}
const _hoisted_64 = { class: "accordion-body" }
const _hoisted_65 = {
  key: 2,
  class: "card recently-visited-card"
}
const _hoisted_66 = { class: "card-body flow" }
const _hoisted_67 = { class: "card-title" }
const _hoisted_68 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_69 = ["href", "title"]
const _hoisted_70 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_71 = ["href", "title"]
const _hoisted_72 = { class: "recently-visited-card--hours-heading d-inline-block" }
const _hoisted_73 = { class: "oz-list" }
const _hoisted_74 = { class: "oz-day" }
const _hoisted_75 = { class: "oz-zusatz" }
const _hoisted_76 = { class: "search-form" }
const _hoisted_77 = { class: "mb-2" }
const _hoisted_78 = { class: "search-form--topic" }
const _hoisted_79 = { for: "" }
const _hoisted_80 = {
  class: "fakedropdown form-control d-flex align-items-center",
  "data-bs-toggle": "collapse",
  href: "#collapseCheckboxenContainer",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseCheckboxen"
}
const _hoisted_81 = { class: "d-none d-lg-inline-flex fake-hover" }
const _hoisted_82 = { class: "search-form--region" }
const _hoisted_83 = { class: "search-form--online-only" }
const _hoisted_84 = { class: "d-md-flex gap-4 mt-12px" }
const _hoisted_85 = {
  class: "collapse collapsible-checkbox-container",
  id: "collapseCheckboxenContainer"
}
const _hoisted_86 = { class: "row" }
const _hoisted_87 = { class: "form-check" }
const _hoisted_88 = ["value", "id"]
const _hoisted_89 = ["for"]
const _hoisted_90 = {
  key: 3,
  class: "col-12 px-xs-0 mt-4 mt-md-0 pe-md-0 padding-ergebnisliste-start appointment-view-ergebnisliste"
}
const _hoisted_91 = {
  id: "ergebnis-liste",
  "aria-live": "polite",
  "aria-relevant": "additions removals",
  ref: "ergebnisliste",
  tabindex: "0",
  "aria-labelledby": "liste-headline"
}
const _hoisted_92 = {
  class: "visually-hidden",
  id: "liste-headline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_control_select = _resolveComponent("control-select")!
  const _component_Liste = _resolveComponent("Liste")!
  const _component_ChatControl = _resolveComponent("ChatControl")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("nav", _hoisted_6, [
                _createElementVNode("ol", _hoisted_7, [
                  _cache[8] || (_cache[8] = _createElementVNode("li", { class: "breadcrumb-item" }, [
                    _createElementVNode("a", { href: "#" }, "Home")
                  ], -1)),
                  _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t('views.login.breadcrumbpage')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[9] || (_cache[9] = _createElementVNode("i", {
                "aria-hidden": "true",
                class: "icon icon--lock-solid"
              }, null, -1)),
              _createElementVNode("div", null, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.login.breadcrumbpage')), 1),
                _createElementVNode("small", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.appointment.loggedinas')) + " " + _toDisplayString(_ctx.user) + " ", 1),
                  _createElementVNode("a", {
                    class: "ms-1",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, _toDisplayString(_ctx.$t('views.appointment.logout')), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("ul", _hoisted_15, [
              (_ctx.$t('views.appointment.termine1') !=='Termine' )
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: _normalizeClass(["login-content--subnav--item", { active: _ctx.isRouteActive('widget-appointment') }]),
                    style: {"hyphens":"manual"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToAppointments && _ctx.navigateToAppointments(...args)))
                  }, [
                    _cache[10] || (_cache[10] = _createElementVNode("i", {
                      "aria-hidden": "true",
                      class: "icon icon--calendar"
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('views.appointment.termine1')) + "­" + _toDisplayString(_ctx.$t('views.appointment.termine2')), 1)
                  ], 2))
                : (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: _normalizeClass(["login-content--subnav--item", { active: _ctx.isRouteActive('widget-appointment') }]),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToAppointments && _ctx.navigateToAppointments(...args)))
                  }, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", {
                      "aria-hidden": "true",
                      class: "icon icon--calendar"
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('views.appointment.termine1')), 1)
                  ], 2)),
              _createElementVNode("li", {
                class: _normalizeClass(["login-content--subnav--item", { active: _ctx.isRouteActive('widget-account') }]),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navigateToAccount && _ctx.navigateToAccount(...args)))
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("i", {
                  "aria-hidden": "true",
                  class: "icon icon--user"
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('views.appointment.account')), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t('views.appointment.termine')), 1),
              (_ctx.appointments.length == 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t('views.appointment.keinetermine')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointments, (appointment, aindex) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "appointment flow",
                    key: aindex
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", {
                          "aria-hidden": "true",
                          class: "icon icon--calendar"
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(new Date(appointment.startTime).toLocaleDateString("de-DE", {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[14] || (_cache[14] = _createElementVNode("i", {
                          "aria-hidden": "true",
                          class: "icon icon--clock"
                        }, null, -1)),
                        _createTextVNode(_toDisplayString(new Date(appointment.startTime).toLocaleTimeString("de-DE", {
                      hour: '2-digit',
                      minute: '2-digit'
                    })) + " - " + _toDisplayString(new Date(appointment.endTime).toLocaleTimeString("de-DE", { hour: '2-digit', minute: '2-digit' })) + " " + _toDisplayString(_ctx.$t('views.appointment.uhr')), 1)
                      ])
                    ]),
                    (!appointment.cancelled && _ctx.checkInTime(appointment.endTime))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (_ctx.checkIfShowButton(appointment.startTime)&& !_ctx.runningAppointment && appointment.type==='CHAT')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-primary-custom",
                                "aria-label": "Test A",
                                onClick: ($event: any) => (_ctx.startAppointment(appointment))
                              }, _toDisplayString(_ctx.$t('views.appointment.btermin')), 9, _hoisted_24))
                            : (_ctx.checkIfShowButton(appointment.startTime)&& _ctx.runningAppointment!=appointment.id && appointment.type==='CHAT')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  disabled: "",
                                  class: "btn btn-primary-custom",
                                  "aria-label": "Test B",
                                  onClick: ($event: any) => (_ctx.startAppointment(appointment))
                                }, _toDisplayString(_ctx.$t('views.appointment.btermin')), 9, _hoisted_25))
                              : (_ctx.runningAppointment === appointment.id)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_26, " Beratung läuft gerade "))
                                : (appointment.meetingVideoURL && appointment.type==='VIDEO' && _ctx.checkIfShowButton(appointment.startTime) && !_ctx.runningAppointment)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 3,
                                      class: "btn btn-primary-custom",
                                      "aria-label": "Test D",
                                      style: {"text-decoration":"none"},
                                      target: "_blank",
                                      href: _ctx.formatURL(appointment.meetingVideoURL)
                                    }, _toDisplayString(_ctx.$t('views.appointment.btermin')), 9, _hoisted_27))
                                  : (appointment.type==='VIDEO' && (_ctx.checkIfShowButton(appointment.startTime)|| _ctx.runningAppointment))
                                    ? (_openBlock(), _createElementBlock("button", _hoisted_28, _toDisplayString(_ctx.$t('views.appointment.btermin')), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                        _createElementVNode("button", _hoisted_30, _toDisplayString(_ctx.$t('views.appointment.disabledButton')), 1)
                                      ])),
                          (!_ctx.checkIfShowButton(appointment.startTime))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 6,
                                class: "btn btn-link",
                                onClick: ($event: any) => (_ctx.cancelAppointment(appointment.id))
                              }, _toDisplayString(_ctx.$t('views.appointment.cancel')), 9, _hoisted_31))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('views.appointment.advisor')), 1),
                      _createTextVNode(" " + _toDisplayString(appointment.advisorName) + " ", 1),
                      _createElementVNode("a", {
                        href: _ctx.getSearchLink(appointment.counselingCenterId),
                        class: "d-block"
                      }, _toDisplayString(_ctx.ccNames.get(appointment.counselingCenterId)), 9, _hoisted_33)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('views.appointment.type')), 1),
                      _createTextVNode(" " + _toDisplayString(appointment.type), 1)
                    ])
                  ]))
                }), 128))
              ]),
              (_ctx.canceledAppointments?.totalCount || 0 > 0)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_35, _toDisplayString(_ctx.$t('views.appointment.abgesagtetermine')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canceledAppointments.content, (appointment, aindex) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "appointment flow",
                    key: aindex
                  }, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _cache[15] || (_cache[15] = _createElementVNode("i", {
                          "aria-hidden": "true",
                          class: "icon icon--calendar"
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(new Date(appointment.startTime).toLocaleDateString("de-DE", {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })), 1)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _cache[16] || (_cache[16] = _createElementVNode("i", {
                          "aria-hidden": "true",
                          class: "icon icon--clock"
                        }, null, -1)),
                        _createTextVNode(_toDisplayString(new Date(appointment.startTime).toLocaleTimeString("de-DE", {
                      hour: '2-digit',
                      minute: '2-digit'
                    })) + " - " + _toDisplayString(new Date(appointment.endTime).toLocaleTimeString("de-DE", { hour: '2-digit', minute: '2-digit' })) + " " + _toDisplayString(_ctx.$t('views.appointment.uhr')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      (appointment.cancellationSource && appointment.cancellationSource == 'CLIENT')
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_41, [
                            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('views.appointment.fromme')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (appointment.cancellationSource && appointment.cancellationSource == 'ADVISOR')
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_42, [
                            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('views.appointment.from')) + " " + _toDisplayString(appointment.advisorName) + " " + _toDisplayString(_ctx.$t('views.appointment.done')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (appointment.cancellationNote)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_43, [
                            _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(appointment.cancellationNote), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkClientCancellation(appointment) && !(appointment.cancellationSource == 'CLIENT' || appointment.cancellationSource == 'ADVISOR'))
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_44, [
                            _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('views.appointment.fromme')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkClientCancellation(appointment))
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_45, [
                            _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.getClientCancellation(appointment)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('views.appointment.advisor')), 1),
                      _createTextVNode(" " + _toDisplayString(appointment.advisorName) + " ", 1),
                      _createElementVNode("a", {
                        href: _ctx.getSearchLink(appointment.counselingCenterId),
                        class: "d-block"
                      }, _toDisplayString(_ctx.ccNames.get(appointment.counselingCenterId)), 9, _hoisted_47)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('views.appointment.type')), 1),
                      _createTextVNode(" " + _toDisplayString(appointment.type), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("h2", _hoisted_51, [
                    _createElementVNode("button", _hoisted_52, _toDisplayString(_ctx.$t('views.login.sometext')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("ol", _hoisted_55, [
                        _createElementVNode("li", _hoisted_56, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.login.sometext1')), 1)
                        ]),
                        _createElementVNode("li", _hoisted_57, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.login.sometext2')), 1)
                        ]),
                        _createElementVNode("li", _hoisted_58, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.login.sometext3')), 1)
                        ]),
                        _createElementVNode("li", _hoisted_59, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.login.sometext4')), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("h2", _hoisted_61, [
                    _createElementVNode("button", _hoisted_62, _toDisplayString(_ctx.$t('views.appointment.help')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('views.appointment.helptext')), 1)
                  ])
                ])
              ]),
              (_ctx.counselingCenter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("h5", _hoisted_67, _toDisplayString(_ctx.$t('views.appointment.lastviewed')), 1),
                      _createVNode(_component_router_link, {
                        to: '/counseling-center/' + _ctx.counselingCenter?.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.counselingCenter.name), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      (_ctx.counselingCenter?.phoneCounseling)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _cache[22] || (_cache[22] = _createElementVNode("div", {
                              class: "icon svg-tel",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createElementVNode("a", {
                              href: _ctx.formattedPhoneHref(_ctx.counselingCenter?.phoneCounseling),
                              title: _ctx.$t('views.appointment.callphone'),
                              class: "h3link"
                            }, _toDisplayString(_ctx.formattedPhoneHref(_ctx.counselingCenter?.phoneCounseling)), 9, _hoisted_69)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _cache[23] || (_cache[23] = _createElementVNode("div", {
                              class: "icon svg-tel",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createElementVNode("a", {
                              href: _ctx.formattedPhoneHref(_ctx.counselingCenter?.phone),
                              title: _ctx.$t('views.appointment.callphone'),
                              class: "h3link"
                            }, _toDisplayString(_ctx.formattedPhoneHref(_ctx.counselingCenter?.phone)), 9, _hoisted_71)
                          ])),
                      _createElementVNode("h5", _hoisted_72, _toDisplayString(_ctx.$t('views.appointment.when')), 1),
                      _createElementVNode("div", _hoisted_73, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.counselingCenter.openingHours, (oo, oindex) => {
                          return (_openBlock(), _createElementBlock("div", { key: oindex }, [
                            _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t('common.weekdaysShort.' + oo.dayOfWeek?.toUpperCase())), 1),
                            _createTextVNode(" " + _toDisplayString(oo.openingTime) + " - " + _toDisplayString(oo.closingTime) + " ", 1),
                            _createElementVNode("span", _hoisted_75, _toDisplayString(oo.description), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("form", _hoisted_76, [
                _createElementVNode("h2", _hoisted_77, _toDisplayString(_ctx.$t('views.appointment.findcc')), 1),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('views.appointment.topics')), 1),
                  _createElementVNode("a", _hoisted_80, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t('views.appointment.beliebig')) + " ", 1),
                      _createTextVNode(_toDisplayString(_ctx.$t('views.appointment.selecttopics')), 1)
                    ]),
                    _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"chev-icons ms-auto\" data-v-718e9252><div class=\"chev-down\" data-v-718e9252><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-chevron-down\" viewBox=\"0 0 16 16\" data-v-718e9252><path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\" data-v-718e9252></path></svg></div><div class=\"chev-up\" data-v-718e9252><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-chevron-up\" viewBox=\"0 0 16 16\" data-v-718e9252><path fill-rule=\"evenodd\" d=\"M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z\" data-v-718e9252></path></svg></div></div>", 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  (_ctx.availableRegions.length > 0)
                    ? (_openBlock(), _createBlock(_component_control_select, {
                        key: 0,
                        "i18n-label": "common.regions",
                        "available-values": _ctx.availableRegions,
                        modelValue: _ctx.regions,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.regions) = $event))
                      }, null, 8, ["available-values", "modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", {
                    class: "fakelabel d-none d-xl-block m-0",
                    "aria-hidden": "true"
                  }, " ", -1)),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary-custom w-100",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getSearchPageLink()))
                    }, _toDisplayString(_ctx.$t('views.appointment.search')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lookUpValuesTopic, (topic, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-12 col-md-6 col-lg-4"
                      }, [
                        _createElementVNode("div", _hoisted_87, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            value: topic.id,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedTopics) = $event)),
                            id: 'thema_' + index + (_ctx.type != 'overlay' ? '_start' : '')
                          }, null, 8, _hoisted_88), [
                            [_vModelCheckbox, _ctx.selectedTopics]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label checkbox-label d-flex align-items-top",
                            for: 'thema_' + index + (_ctx.type != 'overlay' ? '_start' : '')
                          }, [
                            _createElementVNode("span", null, _toDisplayString(topic.description), 1)
                          ], 8, _hoisted_89)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.counselingCenters && _ctx.counselingCenters.totalCount && _ctx.counselingCenters.totalCount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.$t('searchlist.listHL')), 1),
                      _createVNode(_component_Liste, {
                        cCenter: _ctx.filteredCenter,
                        topics: _ctx.selectedTopics,
                        region: _ctx.regions,
                        lang: _ctx.checkedLanguageType,
                        cType: _ctx.checkedCounselingType,
                        targetGroup: _ctx.checkedTargetGroup,
                        os: _ctx.withOnlineCounseling,
                        long: _ctx.long,
                        lat: _ctx.lat,
                        radiusMap: _ctx.radiusMap,
                        searchTerm: _ctx.searchTerm,
                        mini: true,
                        onSubmit: _ctx.findCounselingCenters,
                        onResetfilter: _ctx.resetFilter
                      }, null, 8, ["cCenter", "topics", "region", "lang", "cType", "targetGroup", "os", "long", "lat", "radiusMap", "searchTerm", "onSubmit", "onResetfilter"])
                    ], 512)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ChatControl, {
      onChatClosed: _ctx.handleChatClosed,
      ref: "chatOverlay",
      onChatMinimized: _ctx.handleChatMinimized,
      "show-update": _ctx.showTimeExtended
    }, null, 8, ["onChatClosed", "onChatMinimized", "show-update"]),
    (_ctx.showMaximizeButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "maximized-indicator",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.maximizeChat && _ctx.maximizeChat(...args)))
        }, _cache[26] || (_cache[26] = [
          _createElementVNode("i", { class: "bi bi-chat-dots-fill" }, null, -1),
          _createTextVNode(" Chat maximieren ")
        ])))
      : _createCommentVNode("", true)
  ]))
}